import React, { useState } from 'react';
import { Icon, color, Button, Typography } from '@kistech/kis-ui';
import { Box as MuiBox } from '@mui/material';
import { useActions } from 'hooks/useActions';
import { actions as kiosksActions, Kiosk, selectors as kiosksSelectors } from 'store/kiosks';
import { useSelector } from 'react-redux';
import { useStyles } from '../styled';

import { KioskHardwareStatus } from './KioskStatus';

export interface KioskHardwareProps {
  kiosk: Kiosk;
}

const KioskHardware = (props: KioskHardwareProps) => {
  const { kiosk } = props;
  const { getKiosk } = useActions({ getKiosk: kiosksActions.getKiosk });
  const { pending: kioskPending } = useSelector(kiosksSelectors.selectAction);
  const [showKioskHardware, setShowKioskHardware] = useState<boolean>(false);

  const onStatusClick = () => {
    getKiosk({ kioskId: kiosk.id });
    if (!kioskPending) setShowKioskHardware(true);
  };

  const onClose = () => {
    setShowKioskHardware(false);
  };
  const classes = useStyles({ showDrawer: showKioskHardware })();
  return (
    <>
      <div className={classes.kioskStatusRow}>
        {kiosk.online ? (
          <Button
            onClick={onStatusClick}
            className={kiosk.status === 'Active' ? classes.kioskActiveText : classes.kioskInactiveText}
          >
            <Icon name="circle" size={11} color={kiosk.status === 'Active' ? color.GREEN : color.RED} />
            {kiosk.status}
          </Button>
        ) : (
          <MuiBox className={classes.kioskInactiveLabel}>
            <Icon name="circle" size={15} style={{ width: '30px' }} color={color.RED} />
            <Typography tag="span">Offline</Typography>
          </MuiBox>
        )}
      </div>
      {/* Drawer as seperate component to avoid showing popup view instead of sliding */}
      <KioskHardwareStatus onClose={onClose} isOpen={showKioskHardware} kiosk={kiosk} />
    </>
  );
};

export default KioskHardware;
